import { getResourceFilterGroups } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
export const useGetResourceFilterGroups = (userId: string) => {
  const { data, status, refetch } = useQuery(
    ['resource-filter-groups', userId],
    () => getResourceFilterGroups(userId)
  );

  return {
    storedFilterGroups: data,
    storedFilterGroupsStatus: status,
    fetchStoredFilterGroups: refetch,
  };
};
